import React, { useState } from "react";
import * as Icon from "react-feather";

import { H5 } from "../../atoms/Texts";
import { toastWarning } from "../../../shared/helpers";
import SearchMember from "./member.search";
import AddTeamMemberForm from "./member.add.form";

export const AddTeamMember = ({ setMode }) => {
  const [searchedUser, setSearchedUser] = useState(null);

  const onAddTeamMember = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  return (
    <div className="bg-white rounded px-6 pt-6 py-10">
      <div className="flex items-center justify-between">
        <H5 color="#22202D" className="uppercase mb-8">
          add team member
        </H5>
        <Icon.X
          color="#9598A3"
          size={24}
          onClick={() => setMode("default")}
          className="cursor-pointer"
        />
      </div>
      <div className="w-full">
        <div className="w-full mx-auto">
          <SearchMember setSearchedUser={setSearchedUser} />
          {searchedUser?.id && (
            <AddTeamMemberForm addMember={onAddTeamMember} loading={false} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddTeamMember;
